import { AgentSessionLabel } from '../../../../api/agent-miner-client/agent-miner-client.type';
import { AgentSource } from '../../../../api/events-client/events-client.type';

const AGENT_SOURCE_VALUES = new Set<string>(Object.values(AgentSource));
const AGENT_SESSION_LABEL_VALUES = new Set<string>(Object.values(AgentSessionLabel));

type DateRangePreset = 'all' | '24h' | '7d' | '30d' | '90d' | 'custom';

const DATE_OPTIONS: { value: DateRangePreset; label: string }[] = [
  { value: 'all', label: 'All time' },
  { value: '24h', label: 'Last 24 hours' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: 'custom', label: 'Custom range' },
];

type SessionsFiltersValue = {
  q: string;
  sources: AgentSource[];
  userIds: string[];
  labels: AgentSessionLabel[];
  dateRange: DateRangePreset;
  customStart: string | null; // YYYY-MM-DD when dateRange === 'custom'
  customEnd: string | null; // YYYY-MM-DD when dateRange === 'custom'
  hasTask: boolean | null;
  hideEmpty: boolean;
  /**
   * Model family display labels (e.g. `"Sonnet 4.5"`). Free-form rather than
   * enum-validated — the backend derives families from raw model ids and
   * returns unmatched ids verbatim, so a new model must be filterable without
   * a frontend deploy.
   */
  modelFamilies: string[];
};

type SessionsFiltersSetters = {
  setQ: (value: string) => void;
  setSources: (values: AgentSource[]) => void;
  setUserIds: (values: string[]) => void;
  setLabels: (values: AgentSessionLabel[]) => void;
  setDateRange: (value: DateRangePreset) => void;
  setCustomRange: (start: string | null, end: string | null) => void;
  setHasTask: (value: boolean | null) => void;
  setHideEmpty: (value: boolean) => void;
  setModelFamilies: (values: string[]) => void;
};

type UseSessionsFilters = {
  value: SessionsFiltersValue;
  reset: () => void;
} & SessionsFiltersSetters;

const DEFAULT_DATE_RANGE: DateRangePreset = '30d';

const DATE_PRESET_MS: Record<Exclude<DateRangePreset, 'all' | 'custom'>, number> = {
  '24h': 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
  '30d': 30 * 24 * 60 * 60 * 1000,
  '90d': 90 * 24 * 60 * 60 * 1000,
};

const RESET_KEYS = [
  'q',
  'source',
  'user_id',
  'label',
  'started',
  'start_date',
  'end_date',
  'has_task',
  'hide_empty',
  'model_family',
] as const;

export {
  AGENT_SESSION_LABEL_VALUES,
  AGENT_SOURCE_VALUES,
  DATE_OPTIONS,
  DATE_PRESET_MS,
  DEFAULT_DATE_RANGE,
  RESET_KEYS,
};
export type { DateRangePreset, SessionsFiltersValue, UseSessionsFilters };
